import styled from 'styled-components';
import theme from 'themes';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;
`;

const ModalHeader = styled.div`
  padding: 1rem;
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid ${theme.colors.lightGrey3};
`;

const Tab = styled.button<{ isActive: boolean }>`
  flex: 1;
  padding: 10px;
  background: ${({ isActive }) => (isActive ? 'white' : 'white')};
  border: none;
  border-bottom: ${({ isActive }) => (isActive ? `2px solid ${theme.colors.donutChart.target}` : 'none')};
  color: ${({ isActive }) => (isActive ? `${theme.colors.donutChart.target}` : 'none')};
  font-weight: 600;
  cursor: pointer;
`;

const Content = styled.div`
  margin-top: 0.625rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const FormContorl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const SmallText = styled.small`
  display: flex;
  > span {
    margin-left: 0.25rem;
    color: ${theme.colors.lightGrey8};
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 0.879rem;
    margin-bottom: 12.5rem;
  }
`;

const WarningTag = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
`;

const ButtonBox = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
  justify-content: flex-end;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 10px;
  font-weight: 400 !important;
  gap: 2rem;

  .radio-label{
  font-weight: 400; !important
  }
`;

export {
  ModalContainer,
  ModalHeader,
  Tabs,
  Tab,
  Content,
  FormGroup,
  FormContorl,
  SmallText,
  WarningTag,
  ButtonBox,
  RadioGroup
};

export const TargetOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SetCustomValueContainer = styled.div`
  margin-bottom: 18px;
  .radio-label {
    font-size: 16px !important;
  }
`;

export const SetTargetValueContainer = styled.div`
  margin-bottom: 16px;
  font-size: 16px;
  .radio-label {
    font-size: 16px !important;
  }
`;

export const ShowHideServicesContainer = styled.div`
  margin-bottom: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 16px;
  p {
    margin: 0px;
  }
  label {
    font-weight: 600;
    font-size: 16px;
    width: auto;
  }
`;

export const SetTargetValueContainerFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 1rem;
`;

export const FormControlDiv = styled.div<{orText?: boolean}>`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.orText ? '18px' : '0px')};
  text-align: ${(props) => (props.orText ? 'center' : 'left')};
  flex: ${(props) => (props.orText ? '0 0 auto' : '1 1 45%')};
  min-width: ${(props) => (props.orText ? 'auto' : '200px')};
`;

export const LabelField = styled.label`
  font-weight: 500;
  margin-bottom: 4px;
`;

export const InputField = styled.input`
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid ${theme.colors.lightGrey3};
  border-radius: 4px;
`;

export const SetCustomValueContainerFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  position: relative;
  margin-top: 10px;
  :before {
    position: absolute;
    content: '';
    width: 1px;
    height: 100%;
    border: 1px solid ${theme.colors.lightGrey3};
    left: 50%;
  }
`;

export const DayFieldConatiner = styled.div`
  display: flex;
  align-items: center;
  width: 48%;
  gap: 3rem;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DayFieldWithCheckbox = styled.label`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 0.5rem;
  width: 30%;
  font-weight: 600;
  font-size: 14px;
  label {
    font-weight: 600;
    width: auto;
  }
`;

export const LastTotalAverageHoursConatiner = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-direction: column;

  p {
    font-size: 1rem;
    margin: 0px;
  }

  p:last-child {
    color: ${theme.colors.lightGrey8};
  }
`;

export const TagetValueStatusConatiner = styled.div`
  border-top: 1px solid ${theme.colors.lightGrey3};
  padding-top: 24px;
  .label-space {
    margin-bottom: 10px;
    font-weight: 600;
  }
`;
